/* unplugin-vue-components disabled */import script from "./likeSet.vue?vue&type=script&lang=ts&setup=true"
export * from "./likeSet.vue?vue&type=script&lang=ts&setup=true"

import "./likeSet.vue?vue&type=style&index=0&id=3740f23e&lang=scss"
import "./likeSet.vue?vue&type=style&index=1&id=3740f23e&lang=scss&scoped=true"

import exportComponent from "/nerv.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3740f23e"]])

export default __exports__